import { getWindow } from '../../../utils/general';
import { getAccountScopedStorageKey } from '../../../utils/user';

const OD_TABLE_HEADERS_BASE_KEY = 'odTableHeaders';

export const getODTableHeadersStorageKey = (): string | null =>
  getAccountScopedStorageKey(OD_TABLE_HEADERS_BASE_KEY);

export const ODTableHeaderData = (
  tableHeaderState: Array<{
    enabled: boolean;
  }>,
) => {
  return [
    {
      title: 'Date Created',
      style: { width: '125px', paddingLeft: '16px' },
      sort: false,
      showHeader: tableHeaderState?.[0]?.enabled,
    },
    {
      title: 'Order #',
      style: { width: '141px', paddingLeft: '16px' },
      sort: false,
      showHeader: tableHeaderState?.[1]?.enabled,
    },
    {
      title: 'Project',
      style: { width: '124px', padding: '0px 0 0px 16px' },
      sort: false,
      showHeader: tableHeaderState?.[2]?.enabled,
    },
    {
      title: 'PO/Job Name',
      style: { width: '124px', paddingLeft: '16px' },
      sort: false,
      showHeader: true,
    },
    {
      title: 'Status',
      style: { width: '110px', paddingLeft: '16px' },
      sort: false,
      showHeader: true,
    },
    {
      title: 'Exception',
      style: { width: '155px', paddingLeft: '16px' },
      sort: false,
      showHeader: tableHeaderState?.[5]?.enabled,
    },
    {
      title: 'Delivery Date',
      style: { width: '122px', textAlign: 'left', paddingLeft: '16px' },
      sort: false,
      showHeader: tableHeaderState?.[6]?.enabled,
    },
  ];
};

// Pure, storage-free defaults for the initial render. localStorage is only
// available client-side, so seeding useState directly from ODTableHeaderValues
// would make the server-rendered defaults diverge from the client's first
// (hydration) render for any returning user with saved settings, causing a
// hydration mismatch. Callers should seed state with this, then apply
// ODTableHeaderValues in a post-mount effect.
export const getDefaultODTableHeaderValues = () => [
  {
    columnName: 'Date Created',
    enabled: true,
  },
  {
    columnName: 'Order #',
    enabled: true,
  },
  {
    columnName: 'Project',
    enabled: true,
  },
  {
    columnName: 'PO/Job Name',
    enabled: true,
  },
  {
    columnName: 'Status',
    enabled: true,
  },
  {
    columnName: 'Exception',
    enabled: true,
  },
  {
    columnName: 'Delivery Date',
    enabled: true,
  },
];

export const ODTableHeaderValues = () => {
  const storageKey = getODTableHeadersStorageKey();
  const tableHeaderValuesLocalStorage =
    (storageKey && getWindow()?.localStorage?.getItem(storageKey)) ?? '';

  if (tableHeaderValuesLocalStorage !== '') {
    const tableHeaderValues = JSON?.parse(tableHeaderValuesLocalStorage);
    return tableHeaderValues;
  }

  return getDefaultODTableHeaderValues();
};
